import apiService from '../../../services/api-client';
import { GetValorizationResponse, GetValorizationsResponse, GetValorizationParams } from '../interfaces/get-valorization';
import { PostValorizationPayloadRequest, PostValorizationResponse } from '../interfaces/post-valorization';

export const valorizationApiService = {
  async getValorization(companyId: number, articleId: number): Promise<GetValorizationResponse> {
    const { data } = await apiService().get<GetValorizationResponse>(
      `company/${companyId}/articles/${articleId}/valorization`
    );
    return data;
  },

  async getValorizations(companyId: number, params: GetValorizationParams): Promise<GetValorizationsResponse> {
    const { data } = await apiService().get<GetValorizationsResponse>(
      `company/${companyId}/valorizations`,
      { params }
    );
    return data;
  },

  async postValorization(
    companyId: number, 
    articleId: number, 
    body: PostValorizationPayloadRequest
  ): Promise<PostValorizationResponse> {
    const { data } = await apiService().post<PostValorizationResponse>(
      `company/${companyId}/articles/${articleId}/valorization`,
      body
    );
    return data;
  },

  async putValorization(
    companyId: number,
    articleId: number,
    valorizationId: number,
    body: PostValorizationPayloadRequest
  ): Promise<PostValorizationResponse> {
    const { data } = await apiService().put<PostValorizationResponse>(
      `company/${companyId}/articles/${articleId}/valorization/${valorizationId}`,
      body
    );
    return data;
  },

  async deleteValorization(companyId: number, articleId: number, valorizationId: number): Promise<void> {
    await apiService().delete(`company/${companyId}/articles/${articleId}/valorization/${valorizationId}`);
  },

  async updateProductPrice(companyId: number, productId: number, price: number): Promise<{ ids: number[] }> {
    const { data } = await apiService().patch<{ ids: number[] }>(
      `company/${companyId}/product/${productId}/price`,
      { price }
    );
    return data;
  },
}; 